
// import axios from "axios";
// import { JwtModel } from "../models/JwtModel";
// import { TokenResponse } from "../models/response/token-response";
// import { UserModel } from "../models/UserModel";
// import { ConnectService } from "../services/connect-service";
// import ExpireStorage from "./ExpireStorage";
// import { Helpers } from "./Helpers";
// import jwt_decode from "jwt-decode";

import axios from "axios";
import ExpireStorage from "./ExpireStorage";
import { Helpers } from "./Helpers";

/** Giris ekraninda gosterilecek "oturum kapandi" mesajinin anahtari. */
export const OTURUM_KAPANDI_ANAHTARI = 'oturumKapandiMesaji';

let oturumKapaniyor = false;

const AxiosInterceptor = () => {
    axios.interceptors.request.use(async function (config: any) {
        var token = await ExpireStorage.getItem(Helpers.getStorageKeys()[1]);
        var language = localStorage.getItem('selected_language');
        var selectedCompanyId = localStorage.getItem("SelectedCompanyId");

        if (token)
            config = {
                ...config,
                headers: {
                    ...config.headers,
                    Authorization: 'Bearer ' + token,
                    SelectedCompanyId: selectedCompanyId
                }
            }

        config = {
            ...config,
            headers: {
                ...config.headers,
                "Accept-Language": language ? language : 'tr',
                SelectedCompanyId: selectedCompanyId
            }
        }

        return config;
    }, function (error) {
        return Promise.reject(error);
    });

    // Oturum sunucuda gecersizse (ornegin sifre degisti, 04.10.2026) kullanici giris ekranina dondurulur.
    // Yalniz oturum anahtariyla gonderilmis isteklerde: giris ekranindaki anahtarsiz istekler dongu yaratmasin.
    axios.interceptors.response.use(function (response) {
        return response;
    }, async function (error) {
        const anahtarliIstek = !!(error?.config?.headers?.Authorization || error?.config?.headers?.authorization);

        if (error?.response?.status === 401 && anahtarliIstek && !oturumKapaniyor) {
            oturumKapaniyor = true;

            await ExpireStorage.removeItem(Helpers.getStorageKeys()[0]);
            await ExpireStorage.removeItem(Helpers.getStorageKeys()[1]);
            localStorage.removeItem(Helpers.getStorageKeys()[4]);
            localStorage.removeItem(Helpers.getStorageKeys()[5]);
            sessionStorage.setItem(OTURUM_KAPANDI_ANAHTARI, 'Oturumunuz sona erdi (şifreniz değişmiş olabilir). Lütfen tekrar giriş yapın.');

            window.location.href = '/';
        }

        return Promise.reject(error);
    });

    // Response interceptor for API calls
    // axios.interceptors.response.use((response) => {
    //     return response
    // }, async function (error) {
    //     const originalRequest = error.config;
    //     if (error.response.status === 401 && !originalRequest._retry) {
    //         try {
    //             var refreshToken = localStorage.getItem(Helpers.getStorageKeys()[4]);
    //             var username = localStorage.getItem(Helpers.getStorageKeys()[5]);

    //             if (refreshToken && username) {
    //                 var response: TokenResponse = await ConnectService.refresh_token(refreshToken);

    //                 const decoded: JwtModel = jwt_decode(response.access_token);
    //                 var _type = typeof (decoded.role)
    //                 var authCodes: any = _type === 'string' ? [decoded.role] : decoded.role

    //                 var user: UserModel = {
    //                     token: response.access_token,
    //                     username: username,
    //                     authCodes: authCodes,
    //                     refreshToken: response.refresh_token
    //                 }

    //                 await ExpireStorage.setItem(Helpers.getStorageKeys()[0], JSON.stringify(user), (response.expires_in / 60));
    //                 await ExpireStorage.setItem(Helpers.getStorageKeys()[1], response.access_token, (response.expires_in / 60));
    //                 localStorage.setItem(Helpers.getStorageKeys()[4], response.refresh_token)
    //                 localStorage.setItem(Helpers.getStorageKeys()[5], username);

    //                 axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.access_token;
    //                 originalRequest._retry = true;

    //                 return axios(originalRequest);
    //             }
    //         } catch (err2) {

    //         }
    //     }
    //     return Promise.reject(error);
    // });
}

export default AxiosInterceptor;